import React, { ComponentProps, useEffect, useRef } from 'react'

import { Grid } from '@mui/material'

import { useMegaMenuContext } from './MegaMenuContext'
import { StyledPanelWrapper, StyledTarget } from './styledNavDropdown'

export type NavDropdownMegaMenuWrapperProps = Omit<
ComponentProps<typeof Grid>, 'container' | 'justifyContent' | 'alignItems' | 'as' | 'ref' | 'sx' | 'wrap'
> & {
  //
}

export const NavDropdownMegaMenuWrapper: React.FC<NavDropdownMegaMenuWrapperProps> = ({ children, ...props }) => {
  const { underlineStyle, setMenuState, setUnderlineStyle } = useMegaMenuContext()
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef && containerRef.current) {
      const targetDimensions = containerRef.current.getBoundingClientRect()
      const top = targetDimensions.bottom + window.pageYOffset

      setMenuState((prev) => ({
        ...prev,
        offsetY: top,
      }))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, containerRef.current])

  const onMouseLeave = () => {
    setUnderlineStyle((prev) => ({
      ...prev,
      transform: 'scaleX(0)',
      opacity: 1,
    }))

    setTimeout(() => {
      setUnderlineStyle((prev) => ({
        ...prev,
        width: 0,
      }))

      setMenuState((prev) => ({
        ...prev,
        tabsActive: -1,
      }))
    }, 200)
  }

  return (
    <StyledPanelWrapper
      container
      ref={containerRef}
      alignItems="flex-start"
      justifyContent="space-between"
      wrap="nowrap"
      onMouseLeave={onMouseLeave}
      gap={5}
      {...props}
    >
      {children}
      <StyledTarget
        sx={{
          width: `${underlineStyle.width}px`,
          left: `${underlineStyle.left}px`,
          transform: underlineStyle.transform,
        }}
      />
    </StyledPanelWrapper>
  )
}
